import { render, staticRenderFns } from "./registry_search.vue?vue&type=template&id=e1afebd2&"
import script from "./registry_search.vue?vue&type=script&lang=js&"
export * from "./registry_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports